export default {
  capitalizeFirstLetter(input) {
    if (typeof input === 'string' || input instanceof String) {
      return input.charAt(0).toUpperCase() + input.slice(1);
    }
    return input;
  }
};
